import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Marketplace feed on desktop ("Novosti za Marketplace na stolnom računalu"): a listing tile with the logo on the image. */
@Component({
  selector: 'app-meta-marketplace-feed-desktop',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './marketplace-feed-desktop.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/marketplace-styles.scss',
    './marketplace-feed-desktop.component.scss',
  ]
})
export class MetaMarketplaceFeedDesktopPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }
}